import { ChevronDown, ChevronUp } from 'lucide-react';

/** Up/down reorder controls for an ordered list row. */
export function ReorderButtons({
  index,
  count,
  onMove,
}: {
  index: number;
  count: number;
  onMove: (dir: -1 | 1) => void;
}) {
  return (
    <div className="flex flex-col">
      <button
        type="button"
        aria-label="Move up"
        disabled={index === 0}
        onClick={() => onMove(-1)}
        className="text-muted-foreground hover:text-foreground -my-0.5 disabled:opacity-30 disabled:hover:text-current"
      >
        <ChevronUp className="size-4" />
      </button>
      <button
        type="button"
        aria-label="Move down"
        disabled={index === count - 1}
        onClick={() => onMove(1)}
        className="text-muted-foreground hover:text-foreground -my-0.5 disabled:opacity-30 disabled:hover:text-current"
      >
        <ChevronDown className="size-4" />
      </button>
    </div>
  );
}
